import { useState } from 'react';
import TopNavbar from '../../components/ui/TopNavbar';

import Button from '../../components/ui/Button';





import CostDataGrid from './components/CostDataGrid';


import CostSummaryCards from './components/CostSummaryCards';


const CostRegister = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [dateRange, setDateRange] = useState('thisMonth');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedCostId, setSelectedCostId] = useState(null);
  const [showDetailPanel, setShowDetailPanel] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedCosts, setSelectedCosts] = useState([]);

  const mockCosts = [
    {
      id: 'CST-2024-001',
      date: '2024-12-10',
      vendor: 'SGS Australia Pty Ltd',
      category: 'inspection',
      categoryLabel: 'Inspection Costs',
      description: 'Coal quality inspection at Newcastle Port for Shipment SHP-2024-156',
      amount: 3250.00,
      currency: 'AUD',
      status: 'approved',
      documents: 3,
      shipmentRef: 'SHP-2024-156'
    },
    {
      id: 'CST-2024-002',
      date: '2024-12-09',
      vendor: 'ALS Laboratory Group',
      category: 'lab',
      categoryLabel: 'Lab Expenses',
      description: 'Comprehensive coal analysis including ash content, moisture, and calorific value testing',
      amount: 1850.00,
      currency: 'AUD',
      status: 'reimbursed',
      documents: 2,
      shipmentRef: 'SHP-2024-156'
    },
    {
      id: 'CST-2024-003',
      date: '2024-12-08',
      vendor: 'Customs Connect',
      category: 'customs',
      categoryLabel: 'Customs Broker Fees',
      description: 'Export documentation and customs clearance services for December shipments',
      amount: 950.00,
      currency: 'AUD',
      status: 'approved',
      documents: 4,
      shipmentRef: 'SHP-2024-157'
    },
    {
      id: 'CST-2024-004',
      date: '2024-12-07',
      vendor: 'DHL Express Australia',
      category: 'courier',
      categoryLabel: 'Courier Costs',
      description: 'Express delivery of original B/L documents to RNR India office',
      amount: 285.50,
      currency: 'AUD',
      status: 'pending',
      documents: 1,
      shipmentRef: 'SHP-2024-155'
    },
    {
      id: 'CST-2024-005',
      date: '2024-12-06',
      vendor: 'Qantas Business Travel',
      category: 'travel',
      categoryLabel: 'Travel Expenses',
      description: 'Site visit to Hunter Valley coal mines for quality assessment and supplier meetings',
      amount: 2450.00,
      currency: 'AUD',
      status: 'processing',
      documents: 5,
      shipmentRef: null
    },
    {
      id: 'CST-2024-006',
      date: '2024-12-05',
      vendor: 'Bureau Veritas',
      category: 'inspection',
      categoryLabel: 'Inspection Costs',
      description: 'Pre-shipment inspection and draft survey at Port Kembla',
      amount: 2980.00,
      currency: 'AUD',
      status: 'approved',
      documents: 3,
      shipmentRef: 'SHP-2024-158'
    },
    {
      id: 'CST-2024-007',
      date: '2024-12-04',
      vendor: 'FedEx Australia',
      category: 'courier',
      categoryLabel: 'Courier Costs',
      description: 'Urgent shipment of LC documents and certificates of origin',
      amount: 195.00,
      currency: 'AUD',
      status: 'reimbursed',
      documents: 2,
      shipmentRef: 'SHP-2024-154'
    },
    {
      id: 'CST-2024-008',
      date: '2024-12-03',
      vendor: 'Clayton Utz',
      category: 'legal',
      categoryLabel: 'Legal Costs',
      description: 'Contract review and legal consultation for new supplier agreement',
      amount: 4500.00,
      currency: 'AUD',
      status: 'pending',
      documents: 1,
      shipmentRef: null
    },
    {
      id: 'CST-2024-009',
      date: '2024-12-02',
      vendor: 'SGS Australia Pty Ltd',
      category: 'inspection',
      categoryLabel: 'Inspection Costs',
      description: 'Loading supervision and quantity verification at Gladstone Port',
      amount: 3100.00,
      currency: 'AUD',
      status: 'approved',
      documents: 4,
      shipmentRef: 'SHP-2024-159'
    },
    {
      id: 'CST-2024-010',
      date: '2024-12-01',
      vendor: 'ALS Laboratory Group',
      category: 'lab',
      categoryLabel: 'Lab Expenses',
      description: 'Expedited coal quality testing with 24-hour turnaround',
      amount: 2200.00,
      currency: 'AUD',
      status: 'reimbursed',
      documents: 2,
      shipmentRef: 'SHP-2024-153'
    }
  ];

  const summaryData = {
    totalCosts: 245680.50,
    pendingApproval: 34,
    approvedMonth: 142,
    reimbursementsDue: 45230.00
  };

  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'thisWeek', label: 'This Week' },
    { value: 'thisMonth', label: 'This Month' },
    { value: 'lastMonth', label: 'Last Month' },
    { value: 'thisQuarter', label: 'This Quarter' },
    { value: 'thisYear', label: 'This Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const exportOptions = [
    { value: 'csv', label: 'Export as CSV' },
    { value: 'excel', label: 'Export as Excel' },
    { value: 'pdf', label: 'Export as PDF' }
  ];

  const handleAddCost = () => {
    setIsAddModalOpen(true);
  };

  const handleSaveCost = (costData) => {
    console.log('Saving cost:', costData);
    // TODO: Implement actual save with Supabase
    alert('✅ Cost entry added successfully!');
    setIsAddModalOpen(false);
  };

  const handleCategoryFilter = (categories) => {
    setSelectedCategories(categories);
    console.log('Category filters:', categories);
    // TODO: Apply filter logic
  };

  const handleVendorFilter = (vendors) => {
    setSelectedVendors(vendors);
    console.log('Vendor filters:', vendors);
    // TODO: Apply filter logic
  };

  const handleApprovalFilter = (statuses) => {
    setSelectedStatuses(statuses);
    console.log('Approval filters:', statuses);
    // TODO: Apply filter logic
  };

  const handleBulkAction = (action) => {
    const actionMessages = {
      approve: `✅ Approved ${selectedCosts?.length} cost entries`,
      reject: `✅ Rejected ${selectedCosts?.length} cost entries`,
      export: `✅ Exported ${selectedCosts?.length} cost entries`,
      delete: `✅ Deleted ${selectedCosts?.length} cost entries`,
    };
    alert(actionMessages?.[action] || '✅ Bulk action completed');
    setSelectedCosts([]);
  };

  const handleExport = () => {
    alert(`✅ Exporting ${mockCosts?.length} cost entries...`);
  };

  const handleViewDetails = (cost) => {
    setSelectedCostId(cost?.id);
    setShowDetailPanel(true);
  };

  const handleCloseDetails = () => {
    setShowDetailPanel(false);
    setSelectedCostId(null);
  };

  const handleUpdateCost = (updatedData) => {
    console.log('Cost updated:', updatedData);
    // TODO: Implement actual update with Supabase
    alert('✅ Cost entry updated successfully!');
  };

  const handleCostSelect = (costId) => {
    setSelectedCostId(costId);
    setShowDetailPanel(true);
  };

  const handleEdit = (costId) => {
    console.log('Edit cost:', costId);
  };

  const handleDelete = (costId) => {
    console.log('Delete cost:', costId);
  };

  const selectedCost = mockCosts?.find(cost => cost?.id === selectedCostId);

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TopNavbar />
      <div className="flex-1 flex flex-col overflow-hidden mt-[65px]">
        <header className="bg-card border-b border-border px-3 sm:px-4 md:px-6 py-3 sm:py-4 sticky top-[65px] z-20">
          <div className="flex flex-col gap-3 sm:gap-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground truncate">
                  Cost Register
                </h1>
                <p className="text-xs sm:text-sm text-muted-foreground mt-1 line-clamp-2">
                  Comprehensive cost tracking and analysis
                </p>
              </div>
              
              <Button
                variant="default"
                iconName="Plus"
                iconPosition="left"
                className="text-xs sm:text-sm px-3 sm:px-4 py-2 min-h-[44px] sm:min-h-auto"
              >
                Add Cost
              </Button>
            </div>

            {/* Summary cards - responsive grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3">
              <CostSummaryCards summaryData={summaryData} />
            </div>
          </div>
        </header>

        {/* Two-section layout - responsive stacking */}
        <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
          {/* Upper section */}
          <div className="flex-1 flex flex-col overflow-hidden p-3 sm:p-4 md:p-6 border-b lg:border-b-0 lg:border-r border-border">
            <div className="overflow-x-auto -mx-3 sm:mx-0">
              <div className="min-w-[800px] px-3 sm:px-0">
                <CostDataGrid 
                  costs={mockCosts}
                  onCostSelect={handleCostSelect}
                  selectedCostId={selectedCostId}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                />
              </div>
            </div>
          </div>

          {/* Lower section - stacks on mobile */}
          <div className="flex-1 flex flex-col overflow-hidden p-3 sm:p-4 md:p-6">
            <div className="overflow-x-auto -mx-3 sm:mx-0">
              <div className="min-w-[600px] px-3 sm:px-0">
                {/* Additional cost details or charts */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostRegister;